<template>
	<DialogTitle
		:class="clsx(
			className,
			'text-balance text-center text-base/6 font-semibold text-zinc-950 sm:text-wrap sm:text-left sm:text-sm/6 dark:text-white')">
		<slot />
	</DialogTitle>
</template>

<script setup lang="ts">
	import {
		clsx,
	} from "clsx"

	import {
		DialogTitle,
	} from "@headlessui/vue"

	const props = defineProps({
		className: {
			type: String,
			default: "",
		},
	})
</script>